<div class="btn-group predicate" role="group">
    <button [ngClass]="predicate?.org_unit_value ? 'btn-default': 'btn-danger'"
            class="btn btn-secondary dropdown-toggle add-btn"
            type="button"
            [matMenuTriggerFor]="menu">

            @if (predicate?.org_unit_value) {
                <span><strong>{{predicate.org_unit_type}}</strong> {{'is' | translate}} '{{predicate.org_unit_value}}'&nbsp;&nbsp;</span>
            } @else {
                <span>{{'please_select_org_unit_value' | translate}} <strong>{{predicate?.org_unit_type}}</strong></span>
            }
    </button>

    <button type="button" class="btn" [ngClass]="predicate?.org_unit_value ? 'btn-default': 'btn-danger'" (click)="remove.next(predicate.id)">
        <i class="far fa-times remove"></i>
    </button>

    <mat-menu #menu="matMenu">
        @for (value of other_values; track value) {
        <span mat-menu-item [disabled]="!value.eligible" (click)="changeValue(value, predicate.id)">{{value.name}}</span>
        }
    </mat-menu>

</div>